import api from "@/lib/api";

// Upload an artwork file (or Blob) to object storage via the backend. Returns { file_id, url, ... }.
export async function uploadArtFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/upload/file", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data;
}

export async function uploadArtBlob(blob, filename = "mockup.jpg") {
  const f = new File([blob], filename, { type: blob.type || "image/jpeg" });
  return uploadArtFile(f);
}

// Tokenized download URL usable directly in <img src> (img tags cannot send auth headers).
export function artUrl(fileId) {
  if (!fileId) return null;
  const base = process.env.REACT_APP_BACKEND_URL;
  const token = localStorage.getItem("pns_token") || "";
  return `${base}/api/files/${fileId}/download?auth=${encodeURIComponent(token)}`;
}
